import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class SharedService {

  readonly TREE_KEYS = 'treeData';
  readonly DATE_FORMAT = 'D/MM/YYYY';
  treeData: any = signal([]);
  username = signal<string | null>(null);
  private selectedNodes = signal<{ [key: string]: any }>({});
  private mapLocation = signal<any | []>([]);
  tableData = signal<any[]>([]);
  currentSelectedNode = signal<any | null>(null);

  readonly siteCoordinatesMap: Record<string, { lat: number; lng: number }> = {
    "MovieWorld": { lat: -27.903155, lng: 153.315003 },
    "Wet 'n Wild G.C.": { lat: -27.914518, lng: 153.318358 },
    "Sea World": { lat: -27.9559, lng: 153.4257 },
    "Wet 'n Wild Sydney": { lat: -33.807148, lng: 150.910480 }
  }

  chartDateRange: { start: string; end: string } = {
    start: moment().format(this.DATE_FORMAT),
    end: moment().format(this.DATE_FORMAT),
  };

  constructor(){
    const savedUser = sessionStorage.getItem('username');
    if (savedUser) {
      this.username.set(savedUser);
    }
  }

  setUsername(name: string | null) {
    this.username.set(name);
  }

  getUsername(): string | null {
    return this.username();
  }

  setTreeData(data: any): void {
    this.treeData.set(data);
    sessionStorage.setItem(this.TREE_KEYS, JSON.stringify(data));
  }

  setCurrentSelectedNode(node: any) {
    this.currentSelectedNode.set(node);
  }

  setSelectedNode(routeKey: string, node: any) {
    this.selectedNodes.update(prev => ({
      ...prev,
      [routeKey]: node
    }));
  }

  getSelectedNode(key: string) {
    return this.selectedNodes()[key];
  }

  setMapLocation(location: any) {
    this.mapLocation.set(location);
  }

  getMapLocation(): any {
    return this.mapLocation();
  }

  setTableData(data: any[]) {
    this.tableData.set(data);
  }
}
